import '/auto-message/src/common/js/lib/preactPolyfills';
import {h, render} from 'preact';
import App from './components/App';
import { Provider } from 'preact-redux';
import { Component } from 'preact';
import store from '/auto-message/src/redux/store';
import PostMessageProcessor from '/auto-message/src/common/js/lib/PostMessageProcessor';
import Constant from '/auto-message/src/lib/Constant'
import style from './style.scss'

// Register event on post message
require('/auto-message/src/postmessage/on');

if (module.hot) { require('preact/debug');}

export default class Index extends Component {
    componentWillMount(){
        PostMessageProcessor.init('autoMessage', Constant.parentDomain);
    }

	render() {
		return (
            <div>
                <Provider store={store}>
                    <App/>
                </Provider>
            </div>
        )
	}
}



// WEBPACK FOOTER //
// ./index.js